module.exports = require("./ru-BY.d.ts");